import React from "react";
import { Card, Text, Link } from "@merge-api/merge-javascript-shared";
import { Wand } from "lucide-react";
import AddProductionLinkedAccountButton from "../../../linked-accounts/AddProductionLinkedAccountButton";
import { DOCS_MAGIC_LINK_PATH } from "../../../../../router/RouterUtils";

const MagicLinkInfoCard = () => (
  <Card variant="none" className="p-5 break-words w-full bg-teal-0 gap-5 flex flex-col">
    <Text variant="h4" className="flex flex-row gap-3 flex-nowrap items-center">
      <Wand size={16} />
      Magic Link
    </Text>
    <Text>Want to start using Merge Link without writing any code?</Text>
    <Text>
      View our{" "}
      <Link target="_blank" href={DOCS_MAGIC_LINK_PATH}>
        Magic Link
      </Link>{" "}
      guide to send end users a URL to authorize their integrations, instead of authenticating via
      Link in your product!
    </Text>
    <AddProductionLinkedAccountButton isGetStarted />
  </Card>
);

export default MagicLinkInfoCard;
